import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=5ff3ee70&scoped=true"
import script from "./AdditionalServices.vue?vue&type=script&lang=js"
export * from "./AdditionalServices.vue?vue&type=script&lang=js"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=5ff3ee70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3ee70",
  null
  
)

export default component.exports